import { Injectable } from '@angular/core';
import {HttpClient, HttpClientModule , HttpHeaders} from '@angular/common/http' ;
import {AppConstant} from '../AppConstant'
import { Customer } from './customer.model';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(public httpClient : HttpClient ) { }

  Add_Customer_Details_URL= 'addCustomer';


  CreateCustomer(customer: Customer){
    console.log("In service");
    console.log(AppConstant.baseURL + this.Add_Customer_Details_URL);
    return this.httpClient.post(AppConstant.baseURL + this.Add_Customer_Details_URL,customer)
  }
  
}
